import { render, staticRenderFns } from "./GotSickTodayList.vue?vue&type=template&id=0150c35c&scoped=true&"
import script from "./GotSickTodayList.vue?vue&type=script&lang=js&"
export * from "./GotSickTodayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150c35c",
  null
  
)

export default component.exports